// extracted by mini-css-extract-plugin
export default {"title":"pwlVU","icons":"W0h9l"};